import './index.css'
import 'mapbox-gl/dist/mapbox-gl.css'

import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { Toaster } from 'sonner'

import { router } from '@/configs/router.tsx'
import AuthProvider from '@/contexts/auth-context.tsx'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <NuqsAdapter>
        <RouterProvider router={router} />
      </NuqsAdapter>
      <Toaster position="top-right" richColors expand closeButton />
    </AuthProvider>
  </React.StrictMode>,
)
